"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.foundation_repeat = void 0;
exports.foundation_repeat = {
    repeat: {
        repeat_none: 0,
        repeat_1: 1,
        repeat_2: 2,
        repeat_4: 4,
        repeat_8: 8,
        repeat_infinite: 1000,
    },
};
//# sourceMappingURL=repeat.js.map